module.exports = __webpack_public_path__ + "img/tgi-logo-vert.d3291456.png";